import { Injectable } from "@angular/core";
import { BehaviorSubject, Observer } from "rxjs";
import { ApiService } from "../../api-providers/services/api-service";
import { ApiServiceDelegate } from "../../api-providers/services/api-service-delegate";
import { ApiCollection } from "../../api-providers/services/api-collection"; 
import {  AdmitCard, EmailLogResponseModel, EventModel, EventResponseModel, EventSettingResponseModel, EventSettingTemplate, EventSettingTemplateResponseModel, ParticipantGroupResponseModel, SenderAccountResponseModal, StandardResponseModel, TemplateResponseModel, TimezoneResponseModel } from "../models/event.model";
import { EventsComponent } from "src/app/admin/events/events.component";
import { ModelEventFormComponent } from "src/app/components/model-event-form/model-event-form.component";
import { EventDetailComponent } from "src/app/admin/event-detail/event-detail.component";
import { ParticipantEventDetailResponseModel, ParticipantModel } from "../models/participant.model";
import { HttpHeaders, HttpResponse } from "@angular/common/http";
import { AlertService } from "../services/alert.service";
import { SessionResponseModel } from "../models/session.model";
import { ModalDeleteComponent } from "src/app/components/modal-delete/modal-delete.component";
import { ModalImportEventDataComponent } from "src/app/components/modal-import-event-data/modal-import-event-data.component";
import { LoaderService } from "../services/loader.service";
import { ModalAddToEventComponent } from "src/app/components/modal-add-to-event/modal-add-to-event.component";
import { ModalAdmitTemplateComponent } from "src/app/components/modal-admit-template/modal-admit-template.component";
import { EventSettingComponent } from "src/app/admin/event-detail/event-setting/event-setting.component";
import { ParticipantsEmailSendComponent } from "src/app/components/participants-email-send/participants-email-send.component";
import { EmailLogsComponent } from "src/app/admin/event-detail/email-logs/email-logs.component";

@Injectable({
    providedIn: "root",
})

export class EventsViewModel {

    parentEventsComponent: EventsComponent;
    parentModelEventFormComponent: ModelEventFormComponent;
    parentEventDetailComponent: EventDetailComponent;
    parentModalDeleteComponent: ModalDeleteComponent;
    parentModalImportEventDataComponent: ModalImportEventDataComponent;
    parentModalAddToEventComponent: ModalAddToEventComponent
    parentModalAdmitCardComponent:ModalAdmitTemplateComponent;
    eventSettingComponent: EventSettingComponent
    participantsEmailSendComponent:ParticipantsEmailSendComponent
    emailLogsComponent:EmailLogsComponent


    eventsResponseModel = new BehaviorSubject<EventResponseModel>(new EventResponseModel()); 

    emailSenderResponseModel = new BehaviorSubject<SenderAccountResponseModal>(new SenderAccountResponseModal())
    emailLogResponseModel = new BehaviorSubject<EmailLogResponseModel>(new EmailLogResponseModel())
    
    participantsResponseModel = new BehaviorSubject<ParticipantEventDetailResponseModel>(
      new ParticipantEventDetailResponseModel()
    );
  
    eventDetailsResponseModel = new BehaviorSubject<EventModel>(
      new EventModel()
    );

    sessionsResponseModel = new BehaviorSubject<SessionResponseModel>(new SessionResponseModel());
    timezonesResponseModel = new BehaviorSubject<TimezoneResponseModel>(new TimezoneResponseModel());
    templateResponseModel = new BehaviorSubject<TemplateResponseModel>(new TemplateResponseModel());
    eventSettingResponseModel = new BehaviorSubject<EventSettingResponseModel>(new EventSettingResponseModel())
    eventTemplateResponseModel = new BehaviorSubject<EventSettingTemplateResponseModel>(new EventSettingTemplateResponseModel())
    participantGroupResponseModel = new BehaviorSubject<ParticipantGroupResponseModel>(new ParticipantGroupResponseModel())

    constructor(
      private apiService: ApiService,
      private alertService: AlertService,
      private loaderService: LoaderService
       ) {
      
    }

    subscribeToEmailLogResponseModel(
      observer: Observer<EmailLogResponseModel>
    ){
      this.emailLogResponseModel.subscribe(observer);
    }

    subscribeToParticipantsResponseModel(
      observer: Observer<ParticipantEventDetailResponseModel>
    ){
      this.participantsResponseModel.subscribe(observer);
    }

    subscribeToEmailSenderResponseModel(
      observer: Observer<SenderAccountResponseModal>
    ){
      this.emailSenderResponseModel.subscribe(observer);
    }
    subscribeToEmailTemplateResponseModel(
      observer: Observer<EventSettingTemplateResponseModel>
    ){
      this.eventTemplateResponseModel.subscribe(observer);
    }

    subscribeToSessionResponseModel(
      observer: Observer<SessionResponseModel>
    ){
      this.sessionsResponseModel.subscribe(observer);
    }
    subscribeToTimezoneResponseModel(observer:Observer<TimezoneResponseModel>){
      this.timezonesResponseModel.subscribe(observer);
    }

    subscribeToEventDetailModel(
      observer: Observer<EventModel>
    ){
      this.eventDetailsResponseModel.subscribe(observer);
    }

    subscribeToEventsResponse(
        observer: Observer<EventResponseModel>
    ){
        this.eventsResponseModel.subscribe(observer);
    }

    subscribeToTemplatesResponseModel(
      observer: Observer<TemplateResponseModel>
    ){
      this.templateResponseModel.subscribe(observer);
    }

    subscribeToEventSettingModelResponseModel(
      observer: Observer<EventSettingResponseModel>
    ){
      this.eventSettingResponseModel.subscribe(observer);
    }

     getEventSetting(id:string){
       this.loaderService.showLoading();
      let d: ApiServiceDelegate = {
        Data: {},
        Method: "GET",
        Action: ApiCollection.Event_Setting + '?event=' + id ,
        Success: (e: any) => {
          this.eventSettingResponseModel.next(e);
          this.eventSettingComponent.eventSettingsRecieved();
          this.loaderService.hideLoading();
          return e; 
        },
        Error: (e: String) => { 
          return e;
        },
      };
      this.apiService.callService(d);
    }

     getParticipantGroup(){
      let d: ApiServiceDelegate = {
        Data: {},
        Method: "GET",
        Action: ApiCollection.Participant_group  ,
        Success: (e: any) => {
          this.participantGroupResponseModel.next(e);
          return e; 
        },
        Error: (e: String) => { 
          return e;
        },
      };
      this.apiService.callService(d);
    }

    getEmailLog(id:string,page:number,page_size:number,search:any){
      let str = ApiCollection.Email_log + '?page=' + page + '&page_size=' + page_size + '&event=' + id;
      if(search?.length > 0){
        str += '&search=' + encodeURIComponent(search);
      }
      let d: ApiServiceDelegate = {
        Data: {},
        Method: "GET",
        Action: str,
        Success: (e: any) => {
          this.emailLogResponseModel.next(e);
          this.emailLogsComponent.emailLogsRecieved();
          return e; 
        },
        Error: (e: String) => { 
          return e;
        },
      };
      this.apiService.callService(d);
    }

    getEventSenderList(){
      let d: ApiServiceDelegate = {
        Data: {},
        Method: "GET",
        Action: ApiCollection.Event_Senders + '?page=1&page_size=100',
        Success: (e: any) => {
          this.emailSenderResponseModel.next(e);
          return e; 
        },
        Error: (e: String) => { 
          return e;
        },
      };
      this.apiService.callService(d);
    }

    createEventSetting(data:any){
      this.loaderService.showLoading();
      let d: ApiServiceDelegate = {
        Data: data,
        Method: "POST",
        Action: ApiCollection.Event_Setting ,
        Success: (e: any) => {
          this.loaderService.hideLoading();
          this.alertService.addAlert('Settings created successfully', 'success');
          return e; 
        },
        Error: (e: String) => { 
          this.loaderService.hideLoading();
          this.alertService.addAlert('Unable to create settings', 'danger');
          return e;
        },
      };
      this.apiService.callService(d);
    }

    updateEventSetting(data:any){
      this.loaderService.showLoading();
      let d: ApiServiceDelegate = {
        Data: data,
        Method: "PATCH",
        Action: ApiCollection.Event_Setting + '/' + data.id ,
        Success: (e: any) => {
          this.loaderService.hideLoading();
          this.alertService.addAlert('Settings update successfully', 'success');
          return e; 
        },
        Error: (e: String) => { 
          this.loaderService.hideLoading();
          this.alertService.addAlert('Unable to update settings', 'danger');
          return e;
        },
      };
      this.apiService.callService(d);
    }

     createEventTemplate(data:any){
      this.loaderService.showLoading();
      let d: ApiServiceDelegate = {
        Data: data,
        Method: "POST",
        Action: ApiCollection.Event_Template ,
        Success: (e: any) => {
          this.loaderService.hideLoading();
          return e; 
        },
        Error: (e: String) => { 
          this.loaderService.hideLoading();
          // this.alertService.addAlert('Unable to create template', 'danger');
          return e;
        },
      };
      this.apiService.callService(d);
    }

     updateEventTemplate(data:any,type:string){
      this.loaderService.showLoading();
      let d: ApiServiceDelegate = {
        Data: data,
        Method: "PATCH",
        Action: ApiCollection.Event_Template + '/' + data.id ,
        Success: (e: any) => {
      
          this.loaderService.hideLoading();
          if(type=='templete'){
            this.alertService.addAlert('Templete updated successfully', 'success');
          }else{
            this.alertService.addAlert('Subject updated successfully', 'success');
          }
          
          return e; 
        },
        Error: (e: String) => { 
          this.loaderService.hideLoading();
          this.alertService.addAlert('Unable to update template', 'danger');
          return e;
        },
      };
      this.apiService.callService(d);
    }

     getEventTemplate(id:any){
      this.loaderService.hideLoading();
      let d: ApiServiceDelegate = {
        Data: {},
        Method: "GET",
        Action: ApiCollection.Event_Template + '?event=' + id ,
        Success: (e: any) => {
          this.eventTemplateResponseModel.next(e);
          this.eventSettingComponent.eventTemplateRecieved();
          this.loaderService.hideLoading();
          return e; 
        },
        Error: (e: String) => {
          this.loaderService.hideLoading(); 
          return e;
        },
      };
      this.apiService.callService(d);
    }

    getSessions(){
      let d: ApiServiceDelegate = {
        Data: {},
        Method: "GET",
        Action: ApiCollection.Session + '?page=1&page_size=100',
        Success: (e: any) => {
          this.sessionsResponseModel.next(e);
          return e; 
        },
        Error: (e: String) => { 
          return e;
        },
      };
      this.apiService.callService(d);
    }

    sendTestEmail(data:any){
      this.loaderService.showLoading();
      let str = ApiCollection.Send_Test_Mail
      if(data){
         str += '?email_template=' + data.email_template + '&recipient_email=' + data.recipient_email + '&type=' + data.type
      }
      let d: ApiServiceDelegate = {
        Data: data,
        Method: "GET",
        Action: str ,
        Success: (e: any) => {
          this.loaderService.hideLoading();
          this.alertService.addAlert('Email sent successfully', 'success');
          this.eventSettingComponent.sendTestSuccess()
          return e; 
        },
        Error: (e: String) => { 
          this.loaderService.hideLoading();
          this.alertService.addAlert('Unable to send email', 'danger');
          return e;
        },
      };
      this.apiService.callService(d);
    }

    getTimezones(){
      let d: ApiServiceDelegate = {
        Data: {},
        Method: "GET",
        Action: ApiCollection.Timezone + '?page=1&page_size=1000',
        Success: (e: any) => {
          this.timezonesResponseModel.next(e);
          return e; 
        },
        Error: (e: String) => { 
          return e;
        },
      };
      this.apiService.callService(d);
    }

    getEventById(slug: string, caller:any){ 
      var url = ApiCollection.Event + '/' + slug;
   
      let d: ApiServiceDelegate = {
        Data: {},
        Method: "GET",
        Action: url,
        Success: (e: any) => {
          if(caller == 'eventDetails') {
             this.eventDetailsResponseModel.next(e); 
             this.parentEventDetailComponent.eventReceived();
          } else if(caller == 'setting'){
            this.eventDetailsResponseModel.next(e); 
            this.eventSettingComponent.eventReceived();
          } else if(caller == 'email-logs'){
            this.eventDetailsResponseModel.next(e); 
            this.emailLogsComponent.eventReceived();
          }
         
          return e; 
        },
        Error: (e: String) => { 
          return e;
        },
      };
      this.apiService.callService(d);
    }

    removeParticipantDetailFromEvent(id: string){
      this.loaderService.showLoading();
      let d: ApiServiceDelegate = {
        Data: {},
        Method: "DELETE",
        Action: ApiCollection.Participant_Event_Detail + '/' + id,
        Success: (e: any) => {
          this.parentModalDeleteComponent.deleteSuccess();
          this.loaderService.hideLoading();
          this.alertService.addAlert('Participant removed from the event', 'success');
          return e;
        },
        Error: (e: String) => { 
          this.loaderService.hideLoading();
          this.alertService.addAlert('Unable to remove participant from the event', 'danger');
          return e;
        },
      };
      this.apiService.callService(d);
    }

    deleteEvent(slug: string){
      this.loaderService.showLoading();
      let d: ApiServiceDelegate = {
        Data: {},
        Method: "DELETE",
        Action: ApiCollection.Event + '/' + slug,
        Success: (e: any) => {
          this.parentModalDeleteComponent.deleteSuccess();
          this.loaderService.hideLoading();
          return e;
        },
        Error: (e: String) => { 
          this.loaderService.hideLoading();
          return e;
        },
      };
      this.apiService.callService(d);
    }

    getEvents(name: string, page_index:number, page_size:number, caller: string){ 
      this.loaderService.showLoading();
      var url = ApiCollection.Event + "?page="+page_index+"&page_size="+page_size;
      if(name.length > 0){
        url += "&name=" + encodeURIComponent(name);;
      }
      let d: ApiServiceDelegate = {
        Data: {},
        Method: "GET",
        Action: url,
        Success: (e: any) => {
          this.eventsResponseModel.next(e); 
          if(caller === 'events'){
            this.parentEventsComponent.eventReceived(e);
          }
          if(caller === 'add-to-events'){
            this.parentModalAddToEventComponent.eventReceived();
          }

          this.loaderService.hideLoading();
          return e; 
        },
        Error: (e: String) => { 
          this.loaderService.hideLoading();
          return e;
        },
      };
      this.apiService.callService(d);
    }

    createOrUpdateEvent(event: EventModel){
      this.loaderService.showLoading();
      var url = ApiCollection.Event;
      if(event.slug){
        url += "/" + event.slug
      }
      let d: ApiServiceDelegate = {
        Data: event,
        Method: event.slug ? 'PATCH':'POST',
        Action: url,
        Success: (e: any) => {
          this.parentModelEventFormComponent.updatedEventMedel(e);
          this.alertService.addAlert(event.slug ? 'Event updated!':'Event created!', 'success');
          this.loaderService.hideLoading();
          return e;
        },
        Error: (e: String) => { 
          this.alertService.addAlert(event.slug ? "Unable to update event":'Event is not created!', 'danger');
          this.loaderService.hideLoading();
          return e;
        },
      };
      this.apiService.callService(d);
    }


    getParticipants(eventId: string, name: string,pageNo:number,page_size:number, attendance: null | boolean, sessions: number[],caller:string){ 
      var url = ApiCollection.Participant_Event_Detail + "?page="+pageNo+"&page_size="+page_size + "&e=" + eventId;
      if(name.length > 0){
        url += "&participant_name=" + encodeURIComponent(name);
      }
      if(attendance != null){
        url += "&attendance=" + attendance;
      }
      if(sessions.length > 0){
        url += "&session=" + sessions.join(',');
      }
      this.loaderService.showLoading();
      let d: ApiServiceDelegate = {
        
        Data: {},
        Method: "GET",
        Action: url,
        Success: (e: any) => {
          
          e.results.forEach((element: any) => {
            if(element.participant_details.phone != null){
              element.participant_details.phone =  JSON.parse(element.participant_details.phone)
            } else {
              element.participant_details.phone = []
            }
          });
          this.participantsResponseModel.next(e); 
          
          if(caller === 'participants'){
            this.parentEventDetailComponent.participantsReceived(e);
          }
          this.loaderService.hideLoading();
          return e; 
        },
        Error: (e: String) => { 
          if(caller === 'participants'){
            this.parentEventDetailComponent.participantsReceived(e);
          }
          this.loaderService.hideLoading();
          return e;
        },
      };
      this.apiService.callService(d);
    }


    downloadQR(slug: string){
      this.loaderService.showLoading();
      this.apiService.downloadFile(ApiCollection.DowloadEventQR + '?slug=' + slug).subscribe((e: any) => {
        const blob = new Blob([e], {
          type: 'application/zip'
        });
        const url = window.URL.createObjectURL(blob);
        window.open(url);
        this.loaderService.hideLoading();
      },
        (error: any) => {
          console.log(error)
          this.loaderService.hideLoading();
        }
      );
    }
 
    exportEventData(slug: string, name: string){
      this.loaderService.showLoading();
      this.apiService.downloadCSVFile(ApiCollection.ExportEventData +'/'+ slug).subscribe((e: any) => {
        const blob: any = new Blob([e.body], { type: 'text/csv' });
        const filename = name
        let link = document.createElement("a");
        if (link.download !== undefined) {
          let url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", filename+".csv");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); 
        }
        this.loaderService.hideLoading();
      },
        (error: any) => {
          console.log(error);
          this.loaderService.hideLoading();
        }
      );
    }


    importEventData(file: File, eventId: string){
      this.loaderService.showLoading();
      this.apiService.uploadCSVFile((ApiCollection.ImportEventData + "?event=" + eventId), file).subscribe((response)=> {
        this.parentModalImportEventDataComponent.importComplete();
        this.loaderService.hideLoading();
        this.alertService.addAlert('Participants imported', 'success');
      },
      (error: any) => {
        console.log(error);
        this.loaderService.hideLoading();
        this.alertService.addAlert('Unable to import participants', 'success');
      }
      )
    }


    addParticipantToEvent(participantId: number, eventId: number){
      var url = ApiCollection.Participant_Event_Detail;
      let d: ApiServiceDelegate = {
        Data: {
          participant: participantId,
          event: eventId
        },
        Method: 'POST',
        Action: url,
        Success: (e: any) => {
          this.parentModalAddToEventComponent.addedToEvent();
          this.alertService.addAlert('Participant added to event', 'success');
          this.loaderService.hideLoading();
          return e;
        },
        Error: (e: any) => { 
          this.parentModalAddToEventComponent.closeModalOnError();      
          this.alertService.addAlert('Participant is already in the event', 'danger');  
          this.loaderService.hideLoading();
          return e;
        },
      };
      this.apiService.callService(d);
    }

    // saveTemplate(frontFile: File,backFile:File,config_id:any){
    //   var formData = new FormData();
    //   formData.set('config_id', config_id);
    //   var httpHeaders = new HttpHeaders();
    //   var uploadContentType = { type: 'multipart/form-data' }
    //   const blob = new Blob([frontFile], uploadContentType);
    //   formData.append('frontfile', blob, frontFile.name);
    //   const backblob = new Blob([backFile], uploadContentType);
    //   formData.append('backfile', backblob, frontFile.name);
    //   httpHeaders.append('Accept', 'application/x-www-form-urlencoded');

    //   this.apiService.uploadFile(String(ApiCollection.SaveTemplate), formData,  httpHeaders).subscribe((e: any) => {

    //     this.alertService.addAlert('Templates saved successfully', 'success');
    // },
    // (error: any) => {
    //     if (error.Errors.media_file[0] ) {
    //         this.alertService.addAlert(' File size too big', 'danger');
    //     }
    //     else {
    //     this.alertService.addAlert('Something went wrong', 'danger');
    //     }
    // }
    // );

    // }
  
    getTemplates(){
      let d: ApiServiceDelegate = {
        Data: {},
        Method: "GET",
        Action: ApiCollection.Template + '?page=1&page_size=100',
        Success: (e: any) => {
          this.templateResponseModel.next(e);
          return e; 
        },
        Error: (e: String) => { 
          return e;
        },
      };
      this.apiService.callService(d);
    }

     sendAdmitCard(data:any){
     this.loaderService.showLoading();
      var url = ApiCollection.AdmitCard + '/send_email';
      
      let d: ApiServiceDelegate = {
        Data: data,
        Method: 'POST',
        Action: url,
        Success: (e: any) => {
          this.participantsEmailSendComponent.cardSend();
          this.alertService.addAlert( 'Card send successfully!', 'success');
          this.loaderService.hideLoading();
          return e;
        },
        Error: (e: any) => { 
          this.alertService.addAlert( JSON.stringify(e) , 'danger');
          this.loaderService.hideLoading();
          return e;
        },
      };
      this.apiService.callService(d);
    }

    createOrUpdateAdmitCard(card: AdmitCard){
     
      var url = ApiCollection.AdmitCard;
      if(card.id){
        url += "/" + card.id
      }
      let d: ApiServiceDelegate = {
        Data: card,
        Method: card.id ? 'PATCH':'POST',
        Action: url,
        Success: (e: any) => {
          this.parentModalAdmitCardComponent.closeWithSuccess();
          this.alertService.addAlert(card.id ? 'Card updated!':'Card created!', 'success');
          return e;
        },
        Error: (e: String) => { 
          this.alertService.addAlert(card.id ? "Unable to update card":'Card is not created!', 'danger');
          return e;
        },
      };
      this.apiService.callService(d);
    }

    getAdmitCard(event_id:any,caller:any){
      var url = ApiCollection.AdmitCard +"?event_id="+event_id;
   


      let d: ApiServiceDelegate = {
        Data: {},
        Method: "GET",
        Action: url,
        Success: (e: any) => {

          if (caller=='admitModal'){

            this.parentModalAdmitCardComponent.admitCardReceived(e);
          }else if (caller=='eventDetail'){
            this.parentEventDetailComponent.cardReceived(e);
          }
          return e; 
        },
        Error: (e: String) => { 
          return e;
        },
      };
      this.apiService.callService(d);

    }
    
    downloadEventAdmitCards(slug: string, fileName: string){
      this.loaderService.showLoading();
      this.apiService.downloadImage(ApiCollection.DownloadAdmitCard + '?event_slug=' + slug).subscribe((e: any) => { 
        function downloadUrl(url: string, fileName: string) {
          const a: any = document.createElement('a');
          a.href = url;
          a.download = fileName;
          document.body.appendChild(a);
          a.style = 'display: none';
          a.click();
          a.remove();
        };
        const url = URL.createObjectURL(e); 
        downloadUrl(url, (fileName + '.zip'));  
        this.loaderService.hideLoading();
      },
        (error: any) => {
          this.loaderService.hideLoading();
          console.log(error);
        }
      );
    }

}
